import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Switch,
  Text,
  Textarea,
  VStack,
  Avatar,
  Badge,
  Flex,
  Box,
  useToast,
  Checkbox,
} from "@chakra-ui/react";
import axios from "axios";
import { ACCOUNTS_URL, BASE_URL } from "../../../Globalapi/Globalapi";

const Admin_Modal_Pay_Fee = ({
  isOpen,
  onClose,
  feeName,
  feeMasterId,
  onPay,
  defaultAmount = "",
  last,
  amount,
  status,
  studentledid,
  feeId,
  start,
  studentId,
  userId,
}) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    feesGroup: "",
    feesType: feeName,
    amount: defaultAmount,
    collectionDate: "2025-01-03",
    paymentReference: "",
    status: false,
    notes: "",
    selectedFees: [],
  });

  const [studentData, setStudentData] = useState(null);
  const [error, setError] = useState(null);
  const [ledgerId, setLedgerId] = useState(null); // State for storing the ledgerId
  const [unassignedFees, setUnassignedFees] = useState([]);
  const [assignedFees, setassignedFees] = useState([]);
  const [amt, setAmt] = useState();
  const [BusLedgerId, setBusLedgerId] = useState(null);
  const [StudentLedgerId, setStudentLedgerId] = useState(null);
  console.log("std id", userId);

  // Fetch student data on component mount
  useEffect(() => {
    // const userId = sessionStorage.getItem("user_id"); // Assuming user_id is stored in session
    const fetchStudentData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/student/student_profile.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ pass: userId }),
          }
        );
        const data = await response.json();

        if (data.success) {
          setStudentData(data.data);
        } else {
          setError("Failed to fetch student data.");
          toast({
            title: "Error",
            description: "Failed to fetch student data.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      } catch (err) {
        setError("An error occurred while fetching data.");
        toast({
          title: "Error",
          description: "An error occurred while fetching data.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    fetchStudentData();
  }, [toast]);

  // Fetch Payment Methods and Ledger IDs (Cash or Online)
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      const schoolId = sessionStorage.getItem("school_id");

      try {
        let cashLedgerId, bankLedgerId;

        if (formData.paymentType === "1") {
          // No need to call any additional API for Cash
          const response = await axios.post(
            `${ACCOUNTS_URL}/common/get_default_cash.php`,
            {
              cmp_id: schoolId, // Pass the user_id here
            }
          );
          console.log("====================================");
          console.log(response);
          console.log("====================================");
          const cashLedger = response.data.data[0];

          cashLedgerId = cashLedger.ledg_id; // You can hardcode or retrieve it elsewhere if needed
          setLedgerId(cashLedgerId);
        } else if (formData.paymentType === "2") {
          // Fetch bank ledger ID with POST request
          const responseBank = await axios.post(
            `${ACCOUNTS_URL}/common/get_default_bank.php`,
            {
              cmp_id: schoolId, // Pass the user_id here
            }
          );
          console.log("====================================");
          console.log(responseBank);
          console.log("====================================");
          const bankLedger = responseBank.data.data[0];
          bankLedgerId = bankLedger.ledg_id; // Extract the ledger_id
          setLedgerId(bankLedgerId);
          if (responseBank.data.status === "success") {
            const bankLedger = responseBank.data.data[0];
            bankLedgerId = bankLedger.ledg_id; // Extract the ledger_id
            setLedgerId(bankLedgerId);
          } else {
            toast({
              title: "Error",
              description: "Failed to fetch bank ledger ID.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          }
        }
      } catch (err) {
        toast({
          title: "Error",
          description: "An error occurred while fetching payment methods.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    // Fetch payment method related data and ledger ID
    fetchPaymentMethods();
  }, [formData.paymentType, toast]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    const fetch = async () => {
      const schoolId = sessionStorage.getItem("school_id");
      // const studentId = sessionStorage.getItem("student_id");
      try {
        const response = await axios.post(
          `${BASE_URL}/student/bus/bus_fee_details.php`,
          {
            student_id: studentId,
            school_id: schoolId,
          }
        );
        console.log("fee", response);

        if (response.data.success) {
          // Filter only unpaid fees
          const unpaidFees = response.data.data.filter(
            (fee) => fee.payment_status === "Unpaid"
          );

          // Set the state with filtered data
          setassignedFees(unpaidFees);

          // Assuming you still want to set the first item's ledger IDs
          if (unpaidFees.length > 0) {
            setBusLedgerId(unpaidFees[0].bus_ledger_id);
            setStudentLedgerId(unpaidFees[0].student_ledger_id);
          }
        } else {
          throw new Error("Failed to fetch unassigned fees.");
        }
      } catch (err) {
        toast({
          title: "Error",
          description: "Failed to fetch unassigned fees.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    fetch();
  }, [toast]);

  useEffect(() => {
    const fetchUnassignedFees = async () => {
      const schoolId = sessionStorage.getItem("school_id");
      //   const userId = sessionStorage.getItem("student_id");
      try {
        const response = await axios.post(
          `${BASE_URL}/student/bus/upcoming_bus_fee.php`,
          {
            student_id: studentId,
            school_id: schoolId,
          }
        );
        console.log("un", response);

        if (response.data.success) {
          setUnassignedFees(response.data.data.monthly_breakdown); // Updated to extract the monthly breakdown
        } else {
          throw new Error("Failed to fetch unassigned fees.");
        }
      } catch (err) {
        toast({
          title: "Error",
          description: "Failed to fetch unassigned fees.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    fetchUnassignedFees();
  }, [toast]);

  // Update your handleCheckboxChange function
  const handleCheckboxChange = (feeId) => {
    setFormData((prev) => {
      const selectedFees = prev.selectedFees.includes(feeId)
        ? prev.selectedFees.filter((id) => id !== feeId)
        : [...prev.selectedFees, feeId];
      return { ...prev, selectedFees };
    });
  };

  // Modify the calculateTotalAmount function
  const calculateTotalAmount = () => {
    // Combine assignedFees and unassignedFees, then filter selected fees
    const selectedFeesTotal = [...unassignedFees, ...assignedFees]
      .filter((fee) => formData.selectedFees.includes(fee.month)) // Check selected month fees
      .reduce((sum, fee) => {
        // Check for fee.fee and fee.bus_fee, handle both cases
        const feeAmount =
          fee?.fee || fee?.bus_fee
            ? (fee.fee || fee.bus_fee)
                .toString()
                .replace(/,/g, "")
                .split(".")[0]
            : "0"; // Handle undefined or null values
        return sum + Number(feeAmount);
      }, 0);

    // Add default amount
    const defaultAmountValue = amount
      ? amount.toString().replace(/,/g, "").split(".")[0]
      : "0"; // Handle undefined `amount`

    return selectedFeesTotal + Number(defaultAmountValue);
  };

  // Inside your JSX, calculate the total dynamically when the checkbox is toggled

  const handlePay = async () => {
    setLoading(true);
    // const userId = sessionStorage.getItem("user_id");
    const cmpId = sessionStorage.getItem("cmp_id");
    // const studentId = sessionStorage.getItem("student_id");
    const schoolId = sessionStorage.getItem("school_id"); // Assuming school_id is also stored
    const totalAmount = calculateTotalAmount();
    setAmt(totalAmount);

    try {
      let apiUrl = `${BASE_URL}/student/bus/bus_fee_payment.php`; // Correct API URL
      const paymentMethod =
        formData.paymentType === "1"
          ? "1"
          : formData.paymentType === "2"
          ? "2"
          : "null"; // Default to "cash" if paymentType is neither "1" nor "2"
      const paymentLedgerId = ledgerId; // Example ledger ID for payment, modify according to your system

      const payments = formData.selectedFees
        .map((month) => {
          const fee = unassignedFees.find((fee) => fee.month === month); // Find fee details using the selected month
          if (fee) {
            const startDate = new Date(fee.start_date); // Assuming the fee has a start_date
            const formattedMonth = startDate
              .toISOString()
              .split("T")[0]
              .slice(0, 7); // Format as "YYYY-MM"

            return {
              // fee_id: feeId, // Use fee_id from the data
              month: formattedMonth, // Use the formatted month (YYYY-MM)
              amount: parseFloat(fee.fee).toFixed(2), // Ensure amount is a float with two decimals
              fine_amount: 0, // Assuming no fine, modify as needed
            };
          }
          return null; // In case fee is not found (should not happen)
        })
        .filter(Boolean); // Filter out any null values

      // Add entries for all items in `assignedFees`
      if (assignedFees.length > 0) {
        assignedFees.forEach((feeDetail) => {
          payments.unshift({
            fee_id: feeDetail.id || feeId, // Use fee_id from the feeDetail or fallback to passed feeId
            month: new Date(feeDetail.start_date || Date.now())
              .toISOString()
              .split("T")[0]
              .slice(0, 7), // Use start_date from feeDetail or current date
            amount: parseFloat(feeDetail.bus_fee || amount).toFixed(2), // Use bus_fee from feeDetail or fallback to passed amount
            fine_amount: 0, // Assuming no fine, modify as needed
          });
        });
      }

      console.log("Payments array:", payments);

      const payload = {
        user_id: userId,
        student_id: studentId,
        school_id: schoolId,
        student_ledger_id: StudentLedgerId, // Assuming cmpId is the ledger ID for the student
        bus_ledger_id: BusLedgerId, // Example bus ledger ID, modify as needed
        payments: payments,
        payment_date: new Date().toISOString().split("T")[0], // Date in YYYY-MM-DD format
        payment_method: paymentMethod,
        payment_ledger_id: paymentLedgerId,
      };

      console.log("API URL:", apiUrl);
      console.log("Payload:", payload);

      const response = await axios.post(apiUrl, payload);
      console.log("res", response);

      if (response.data.success) {
        toast({
          title: "Payment Successful",
          description: `Paid ₹${totalAmount} for bus fees.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        if (onPay) {
          onPay(totalAmount); // Trigger any callback you may have after payment is successful
        }
        onClose(); // Close modal or any UI element
      } else {
        toast({
          title: "Payment Failed",
          description: response.data.message || "An error occurred.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast({
        title: "Error",
        description: "An error occurred. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      motionPreset="slideInBottom"
    >
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent
        borderRadius="lg"
        boxShadow="xl"
        bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
        color="gray.700"
        p={6}
        maxW="700px"
        maxH="590px"
        overflow="hidden"
      >
        <ModalHeader>
          <Flex justify="space-between" align="center">
            <Flex align="center" gap={2}>
              <Text fontSize="lg">Collect Fees</Text>
              <Badge colorScheme="teal" fontSize="sm" px={2} py={1}>
                AD124556
              </Badge>
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {/* Student Info Card */}
          {studentData && (
            <Box bg="gray.50" p={3} borderRadius="lg" mb={6}>
              <Flex gap={4}>
                <Avatar
                  size="md"
                  name={studentData.name}
                  src={studentData.imgUrl}
                />
                <Box flex="1">
                  <Flex
                    align="center"
                    justifyContent="space-between"
                    gap={2}
                    mb={2}
                  >
                    <Text fontWeight="semibold">{studentData.name}</Text>
                    <Text color="gray.600">
                      {studentData.class_name}, {studentData.section}
                    </Text>
                    <Box>
                      <Text color="gray.600" fontSize="sm">
                        Total
                      </Text>
                      <Text fontWeight="semibold">
                        ₹{calculateTotalAmount()}
                      </Text>
                    </Box>
                    <Box>
                      <Text color="gray.600" fontSize="sm">
                        Last Date
                      </Text>
                      <Text fontWeight="semibold">{last}</Text>
                    </Box>
                    <Badge
                      colorScheme={status === "paid" ? "green" : "red"}
                      borderRadius="full"
                      variant="subtle"
                    >
                      {status}
                    </Badge>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          )}

          {/* Payment Method */}
          <Flex gap={6} w="full" mb={4}>
            <FormControl>
              <FormLabel>Payment Type</FormLabel>
              <Select
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                value={formData.paymentType}
                onChange={(e) =>
                  handleInputChange("paymentType", e.target.value)
                }
              >
                <option value="">Select</option>
                <option value="1">Cash</option>
                <option value="2">Online</option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel>Payment Reference No</FormLabel>
              <Input
                bg="white"
                _hover={{ borderColor: "teal.300" }}
                placeholder="Enter Payment Reference No"
                value={formData.paymentReference}
                onChange={(e) =>
                  handleInputChange("paymentReference", e.target.value)
                }
              />
            </FormControl>
          </Flex>

          {/* Scrollable Fee Selection Section */}
          <Box
            maxH="150px"
            overflowY="auto"
            px={4}
            mb={4}
            css={{
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            {assignedFees.concat(unassignedFees).map((fee) => {
              const startDate = new Date(fee.start_date);
              const month = startDate.toLocaleString("en-US", {
                month: "long",
              });

              return (
                <Box
                  bg="gray.50"
                  mt={2}
                  p={4}
                  width="100%"
                  borderRadius="lg"
                  mb={4}
                  key={fee.month}
                >
                  <Flex justify="space-between" align="center">
                    <Checkbox
                      isChecked={formData.selectedFees.includes(fee.month)}
                      onChange={() => handleCheckboxChange(fee.month)}
                    >
                      <Text fontWeight="semibold">{month}</Text>
                    </Checkbox>
                    <Text color="gray.600">{`Start Date: ${fee.start_date}`}</Text>
                    <Text>{`Amount: ₹${fee.fee || fee.bus_fee}`}</Text>
                    <Badge colorScheme="blue">{fee.payment_status}</Badge>
                  </Flex>
                </Box>
              );
            })}
          </Box>

          {/* Status and Notes (Fixed at the Bottom) */}
          <FormControl mb={4}>
            <Flex align="center" justify="space-between">
              <FormLabel mb={0}>Status</FormLabel>
              <Switch
                size="md"
                isChecked={formData.status}
                onChange={(e) => handleInputChange("status", e.target.checked)}
              />
            </Flex>
            <Text fontSize="sm" color="gray.600" mt={1}>
              Change the Status by toggle
            </Text>
          </FormControl>

          {/* <FormControl mb={4}>
            <FormLabel>Notes</FormLabel>
            <Textarea
              bg="white"
              _hover={{ borderColor: "teal.300" }}
              placeholder="Add Notes"
              value={formData.notes}
              onChange={(e) => handleInputChange("notes", e.target.value)}
              resize="vertical"
            />
          </FormControl> */}

          {/* Buttons (Fixed at the Bottom) */}
          <Flex gap={4} w="full" justify="flex-end">
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              onClick={handlePay}
              isLoading={loading}
              loadingText="Processing"
            >
              Pay Fees
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default Admin_Modal_Pay_Fee;
